import type { NextFunction, Request, Response } from 'express';

const HTTP_NOT_FOUND = 404;

/** Emails allowed to see the Labels library UI during pilot */
export const LABELS_FEATURE_FLAGGED_USER_EMAILS: readonly string[] = [
	'victor.winberg@pinmeto.com',
	'henrik.ahlqvist@pinmeto.com',
	'lasse.poulsen@pinmeto.com',
	'anneclaire.koch@pinmeto.com',
	'britta.norell@pinmeto.com',
	'kim.johansson@pinmeto.com'
];

const labelsEmails = new Set(LABELS_FEATURE_FLAGGED_USER_EMAILS.map(email => email));

export function labelsFeatureFlagged(email: string | undefined | null): boolean {
	return !!email && labelsEmails.has(email.toLowerCase());
}

/** Feature-flag allowlist + account owner + not demo — used for Labels page and sidebar. */
export function canAccessLabelsDevUi({
	email,
	isDemo = false,
	isOwner = false
}: {
	email: string | undefined | null;
	isDemo?: boolean;
	isOwner?: boolean;
}): boolean {
	if (isDemo || !isOwner) {
		return false;
	}

	return labelsFeatureFlagged(email);
}

export function requireLabels(req: Request, res: Response, next: NextFunction): void {
	if (!labelsFeatureFlagged(req.user?.email)) {
		res.status(HTTP_NOT_FOUND).end();
		return;
	}
	next();
}
